import {Component, Inject, OnInit, ViewEncapsulation} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

import {FlowchartProcessFormComponent} from "../flowchart-process-form/flowchart-process-form.component";
import {FlowchartEquipmentFormComponent} from "../flowchart-equipment-form/flowchart-equipment-form.component";
import {FlowchartImageFormComponent} from "../flowchart-image-form/flowchart-image-form.component";
import {FlowchartStreamFormComponent} from "../flowchart-stream-form/flowchart-stream-form.component";

export interface DialogData {
    flowchart: any,
    component: any
}

@Component({
    selector: 'flowchart-form',
    templateUrl: 'flowchart-form.component.html',
    imports: [
    FlowchartProcessFormComponent,
    FlowchartEquipmentFormComponent,
    FlowchartImageFormComponent,
    FlowchartStreamFormComponent
],
    encapsulation: ViewEncapsulation.None
})

export class FlowchartFormComponent implements OnInit {

    flowchart: any;
    component: any;
    showHints: boolean = false;
    title: string;
    showing_hints: boolean;

    constructor(public dialogRef: MatDialogRef<FlowchartFormComponent>,
                @Inject(MAT_DIALOG_DATA)
                private dialogData: DialogData) {

    }

    ngOnInit(): void {
        this.flowchart = this.dialogData.flowchart;
        this.component = this.dialogData.component;
    }

    save(event) {
        this.dialogRef.close(this.component);
    }

    onCloseClick(): void {
        this.dialogRef.close();
    }

}
